module.exports = __webpack_public_path__ + "img/f_25_02.445fe153.jpg";